import { useTranslation } from "react-i18next";
import {
  TranslationNamespaceEnum,
  TranslationNamespaceEnum as TNS,
} from "src/lib/i18next/types.ts";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { H3 } from "src/components/HeadingV2/HeadingV2.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";

await loadTranslations(TranslationNamespaceEnum.ErrorBoundaryComponent);

export const DefaultErrorBoundary = ({
  error,
  onReset,
}: {
  error?: unknown;
  onReset?: () => void;
}) => {
  const { t } = useTranslation(TNS.ErrorBoundaryComponent);

  return (
    <div
      css={{
        height: "100%",
        width: "100%",
        alignContent: "center",
        textAlign: "center",
      }}
    >
      <H3 style={{ marginTop: 16 }}>{t("title")}</H3>
      <div style={{ marginTop: 4 }}>
        <TextV2 variant={"body1"}>{t("subtitle")}</TextV2>
      </div>

      {onReset && (
        <div
          style={{
            marginTop: 4,
            display: "inline-block",
          }}
        >
          <ButtonV2 size={"sm"} onClick={() => onReset?.()}>
            Retry
          </ButtonV2>
        </div>
      )}
    </div>
  );
};
